/**
 * The featured-projects showcase on a public influencer profile: a strip of project tabs, and the
 * chosen project below it.
 *
 * Thin on purpose. Everything a carousel does lives in carousel.js, shared with the video playlist
 * and the stories zone; everything a project says lives in PublicProjects.cshtml, where the copy
 * comes from dictionary keys. This file only wires the two together.
 *
 * GESTURES ARE OFF because a tab strip is a list of choices, not a deck to flick through — and the
 * project pane below it is a wall of body copy, which is not a swipe surface.
 *
 * WITHOUT SCRIPT every project is readable, which is why the CSS only hides the inactive ones once
 * `is-interactive` has been added here. The before/after inside each one is a checkbox and pure
 * CSS, so it keeps working whether this file ran or not.
 */

import { createCarousel } from "./carousel.js";

const SHOWCASE_SELECTOR = ".js-member-projects";

const setUpShowcase = (showcase) => {
  createCarousel(showcase, {
    slideSelector: ".js-member-projects__pane",
    dotSelector: ".js-member-projects__tab",
    interactiveClass: "is-interactive",
    gestures: false,
  });
};

export default function initMemberProfileProjects() {
  document.querySelectorAll(SHOWCASE_SELECTOR).forEach(setUpShowcase);
}
